<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="ded"><em>Pour Taylor, qui aime les animaux, <br/>les grands autant que les petits.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?7817aa18